import Contact from '../components/contact/Contact'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'

const Contactpage = () => {
    return (
        <div>
        <Navbar/>
        <Contact/>


        <Footer/>

        </div>
    )
}

export default Contactpage